import PropTypes from "prop-types";

import ArticleIcon from "@/icons/ArticleIcon";
import RewardIcon from "@/icons/RewardIcon";
import {
  articleIconCss,
  finalScoresCss,
  lableStyle,
  progressBarContainerCss,
  progressBarContentCss,
  progressBarHeaderCss,
  progressBarTitleCss,
  progressPercentageCss,
  progressPointsCounter,
  rewardIconCss,
} from "./ProgressBarTokensCounter.style";

const propTypes = {
  achievedTokens: PropTypes.number,
  label: PropTypes.string,
  totalTokens: PropTypes.number,
  version: PropTypes.oneOf([
    "BADGE_CARD_VERSION",
    "HEADER_VERSION",
    "DETAILS_CARD_VERSION",
    "TOPIC_CARD_VERSION",
  ]),
  bigSize: PropTypes.bool,
  bold: PropTypes.bool,
  showArticleIcon: PropTypes.bool,
};

const renderTokenCounter = (achievedTokens, totalTokens, bigSize = false) => (
  <div css={progressPointsCounter}>
    <span css={finalScoresCss(bigSize)}>
      {achievedTokens.toLocaleString("en-US")} /{" "}
      {totalTokens.toLocaleString("en-US")}
    </span>
  </div>
);

const ProgressBarTokensCounter = ({
  achievedTokens = 0,
  label,
  totalTokens = 0,
  version,
  bigSize = false,
  showArticleIcon = false,
  bold,
}) => {
  return (
    <div css={progressBarContainerCss(version)}>
      <div css={progressBarHeaderCss}>
        <div css={progressBarTitleCss}>
          {showArticleIcon ? (
            <ArticleIcon css={articleIconCss} />
          ) : (
            <RewardIcon
              css={rewardIconCss}
              aria-hidden={false}
              aria-label="Tokens icon"
            />
          )}
          <h2 css={lableStyle(bigSize, bold)}>{label}</h2>
        </div>
        {renderTokenCounter(achievedTokens, totalTokens, bigSize)}
      </div>
      <div css={progressBarContentCss(version, bigSize)}>
        <div css={progressPercentageCss(achievedTokens, totalTokens)} />
      </div>
    </div>
  );
};

ProgressBarTokensCounter.propTypes = propTypes;
export default ProgressBarTokensCounter;
